import React from 'react';
import { Content } from './styles';

const Description = (props) => (
  <Content
    {...props}>
    <p>
      Consider providing access to your electronic health records. This data
      will allow analysis of trends of disease over time and other factors that
      might accelerate or slow progression. Going through this process will
      provide access through your provider’s online portal. You will be able to
      authorize access up to one year in the future. Providing access to your
      records is optional and voluntary.
    </p>
    <p>
      Choosing to share this data with researchers through the Registry will
      allow us to combine and compare your responses to the modules (about
      family history, quality of life, pain, and others) with your clinical data
      to understand how disease progression looks in different people. We will
      collect data from your health record including:
    </p>
    <ul>
      <li>Details of ADPKD diagnosis and progression</li>
      <li>Current medications</li>
      <li>Vital signs from your clinic visits (such as blood pressure)</li>
      <li>Names and specialties of your health care providers</li>
      <li>
        Past and current related lab results (such as kidney function blood and
        urine tests)
      </li>
      <li>Other potentially related health conditions</li>
    </ul>
    <p>
      We will not collect information that is protected by law, such as mental
      health, HIV status or history of substance abuse.
    </p>
    <p>
      <b>
        We&apos;ll be using our partner, OneRecord, to connect to your health record.
      </b>
    </p>
  </Content>
);

export default Description;
